function fadeInReplacement(element, replacement) {
  element.style.opacity = "0";
  element.innerHTML = replacement.innerHTML;
  element.classList.add("animate--fadeIn--fast");
  element.addEventListener("animationend", function () {
    element.style.opacity = "1";
    element.classList.remove("animate--fadeIn--fast");
  });
}

function serializeArray(form) {
  var field,
    l,
    s = [];
  if (typeof form == "object" && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (var i = 0; i < len; i++) {
      field = form.elements[i];
      if (
        field.name &&
        !field.disabled &&
        field.type != "file" &&
        field.type != "reset" &&
        field.type != "submit" &&
        field.type != "button"
      ) {
        if (field.type == "select-multiple") {
          l = form.elements[i].options.length;
          for (j = 0; j < l; j++) {
            if (field.options[j].selected)
              s[s.length] = { name: field.name, value: field.options[j].value };
          }
        } else if (
          (field.type != "checkbox" && field.type != "radio") ||
          field.checked
        ) {
          s[s.length] = { name: field.name, value: field.value };
        }
      }
    }
  }
  return s;
}

function updateProductMedia(selectedVariant) {
  const productMedia = document.querySelectorAll(".product-gallery-image");

  if (selectedVariant.featured_image) {
    console.log("image id = " + selectedVariant.featured_image.id);

    let variantId = selectedVariant.id;

    productMedia.forEach((image) => {
      if (image.dataset.variant && image.dataset.variant == variantId) {
        image.classList.add("selected");
        image.classList.remove("visually-hidden");
      } else if (image.dataset.variant) {
        image.classList.remove("selected");
        image.classList.add("visually-hidden");
      } else {
        image.classList.remove("selected");
      }
    });

    if (window.matchMedia("(max-width: 800px)").matches) {
      const mediaContainer = document.querySelector(".product-main__gallery");
      if (mediaContainer) {
        console.log("scroll to image");
        mediaContainer.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
  } else {
    productMedia.forEach((image) => {
      image.classList.remove("selected");
    });
  }
}

function updateURL(selectedVariant) {
  if (selectedVariant) {
    window.history.replaceState(null, null, "?variant=" + selectedVariant.id);
  }
}

function updateInputs(selectedVariant, form, pickerInput) {
  let id = form.querySelector(".js-variant-id"),
    qty = form.querySelector(".js-variant-qty"),
    management = form.querySelector(".js-variant-management"),
    policy = form.querySelector(".js-policy"),
    availability = form.querySelector(".js-availability"),
    name = form.querySelector(".js-name"),
    price = form.querySelector(".js-price"),
    comparePrice = form.querySelector(".js-compare-at-price");

  if (selectedVariant) {
      if (id && id.value != null) id.value = selectedVariant.id;
      if (management && management.value != null) management.value = selectedVariant.inventory_management;
      if (policy && policy.value != null) policy.value = selectedVariant.inventory_policy;
      if (availability && availability.value != null) availability.value = selectedVariant.available;
      if (name && name.value != null) name.value = selectedVariant.title;
      if (price && price.value != null) price.value = selectedVariant.price;
      if (comparePrice && comparePrice.value != null) comparePrice.value = selectedVariant.compare_at_price;
  }

  console.log("selectedVariant = " + selectedVariant);

  if (management && management.value === "shopify") {
    qty.value = selectedVariant.inventory_quantity;

    pickerInput.setAttribute("max", selectedVariant.inventory_quantity);
    pickerInput.setAttribute(
      "ariavaluemax",
      selectedVariant.inventory_quantity,
    );
  } else {
    qty.value = 1000;

    pickerInput.setAttribute("max", 1000);
    pickerInput.setAttribute("ariavaluemax", 1000);
  }
}

function cartConfirmation(button) {
  setTimeout(() => {
    button.classList.add("confirmation");
    button.setAttribute("disabled", true);
  }, 600);

  setTimeout(() => {
    button.classList.remove("confirmation");
    button.removeAttribute("disabled");
  }, 5000);
}

function toggleMiniCart() {
  var miniCart = document.getElementById("mini-cart");

  if (html.classList.contains("mini-cart-open")) {
    if (togglePopoverSupported) {
      miniCart.hidePopover();
    }
    miniCart.classList.remove("mini-cart-open");
    html.classList.remove("mini-cart-open");
  } else {
    if (togglePopoverSupported) {
      miniCart.showPopover();
    }
    miniCart.classList.add("mini-cart-open");
    html.classList.add("mini-cart-open");
  }
}

function updateCartItemCounts(dataCartItemCount, dataCartContents) {
  const cartItemCounts = document.querySelectorAll(".js-cart-count"),
    cartItemTotals = document.querySelectorAll(".js-cart-total");

  cartItemCounts.forEach((count) => {
    count.textContent = dataCartItemCount;
  });

  cartItemTotals.forEach((total) => {
    total.textContent = dataCartContents.dataset.cartTotal;
  });

  // if (cartCheck) {
  //     cartTotal.textContent = dataCartContents.dataset.cartTotal;
  // }
}

function isInMiniCart(element) {
  let miniCartContents = element
    ? element.closest(".js-mini-cart-contents")
    : null;
  if (miniCartContents) {
    console.log("in mini cart");
    let isInMiniCart = miniCartContents.length !== 0;
    return isInMiniCart;
  } else {
    console.log("not in mini cart");
  }
  return false;
}

function updateCartContents(
  dataCartContents,
  miniCartContents,
  cartPageContents,
  contents,
) {
  if (lineItem.isInMiniCart(contents)) {
    if (isInMiniCart) {
      miniCartContents.innerHTML = "";
      miniCartContents.appendChild(dataCartContents);
    } else {
      cartPageContents.innerHTML = "";
      cartPageContents.appendChild(dataCartContents);
    }
  }
}

function updateMiniCartLine(items, dataLineItems) {
  items.forEach((item) => {
    const lineItemId = item.id;
    const matchingLineItem = Array.from(dataLineItems).find(
      (item) => item.id === lineItemId,
    );

    if (matchingLineItem) {
      const lineItemInfo = matchingLineItem.querySelector(".line-item__info--row__price");
      const itemInfo = item.querySelector(".line-item__info--row__price");

      if (lineItemInfo && itemInfo && lineItemInfo.innerHTML !== itemInfo.innerHTML) {
        fadeInReplacement(itemInfo, lineItemInfo);
        const priceList = itemInfo.querySelector("ul.line-item-price") || itemInfo;
        priceList.classList.add("is-changed");
        setTimeout(() => priceList.classList.remove("is-changed"), 1000);
      }
    }
  });
}

function updateRemoveLines() {
  console.log("updateRemoveLines");
  const removeLines = document.querySelectorAll(
    ".cart-contents .js-remove-line",
  );
  removeLines.forEach((line) => {
    line.addEventListener("click", lineItem.onLineRemoved);
  });
}
function updateCartItems(
  remove,
  dataCartItemCount,
  dataCartContents,
  miniCartContents,
  cartPageContents,
  contents
) {
  // Update cart item counts and totals
  console.log(" updateCartItems");
  console.log("remove = " + remove);
  let cartItemCounts = document.querySelectorAll(".js-cart-count");

  if (remove) {
    // If removing an item, check if cart is empty, if so, remove all contents, if not, update contents
    cartItemCounts.forEach((count) => {
      count.textContent = dataCartItemCount;
    });

// Check if both elements exist before updating
    

    if (lineItem.isInMiniCart(contents)) {
      if (dataCartItemCount <= 0) {
        console.log("remove all");
        if (miniCartContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(miniCartContents, dataCartContents);
        }
      } else {
        if (miniCartContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(miniCartContents, dataCartContents);
        }
      }
    } else {
      console.log("remove");
      if (dataCartItemCount <= 0) {
        console.log("remove all");
        if (cartPageContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(cartPageContents, dataCartContents);
        }
        let headerCart = document.querySelector(".js-cart-status");

        if (headerCart) {
          headerCart.classList.add("empty");
          headerCart.classList.remove("has-items");
        }
      } else {
        if (cartPageContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(cartPageContents, dataCartContents);
        }
      }
    }
  } else {
    let cartLineItems = document.querySelectorAll(".line-item"),
      dataLineItems = dataCartContents.querySelectorAll(".line-item");

   

    cartLineItems.forEach((item) => {
      let lineItemId = item.id,
        matchingLineItem = Array.from(dataLineItems).find(
          (item) => item.id === lineItemId,
        );

      if (matchingLineItem) {
        // console.log('match')
        let lineItemInfo = matchingLineItem.querySelector(
            ".line-item__info .line-item__price",
          ),
          itemInfo = item.querySelector(".line-item__info .line-item__price");

        if (
          lineItemInfo &&
          itemInfo &&
          lineItemInfo.innerHTML !== itemInfo.innerHTML
        ) {
          fadeInReplacement(itemInfo, lineItemInfo);
        }
      }
    });
  }
}

function updateShareCart(dataCartContents) {
  console.log("updateShareCart");

  let cartShare = document.querySelector("details.share-cart"),
    dataCartShare = dataCartContents.querySelector(".share-cart");

  if (cartShare && dataCartShare) {
    console.log("cartShare exists");

    let shareCartOptions = cartShare.querySelectorAll(".share-cart__option"),
      dataShareCartOptions = dataCartShare.querySelectorAll(
        ".share-cart__option",
      );

    if (shareCartOptions.length > 0 && dataShareCartOptions.length > 0) {
      shareCartOptions.forEach((option, index) => {
        let dataOption = dataShareCartOptions[index];
        if (dataOption) {
          option.setAttribute("data-url", dataOption.dataset.url);
        }
      });
    }
  }

}
// Loop through cart, check variant ids and compare with the selected variant id
// If the variant id matches, update the quantity input with the new quantity
// If the quantity is 0, disable the add to cart button
// If the quantity is not 0, enable the add to cart button

function qtyCartCheck(dataCartContents, selectedVariant) {
  if (productCheck) {
    let dataLineItems = dataCartContents.querySelectorAll(".line-item");
    console.log("dataLineItems = " + dataLineItems);
    dataLineItems.forEach((item) => {
      qtyInCart(item);
    });
  }
}

function qtyInCart(item) {
  if (productCheck) {
      lineItemId = item.querySelector(".js-variant-input-id").value,
      lineItemQty = item.querySelector(".js-line-quantity").value,
      selectedVariantId = document.querySelector(".js-variant-id").value,
      selectedVariantQty = document.querySelector(".js-variant-qty").value,
      newQty = selectedVariantQty - lineItemQty,
      addToCartForm = document.getElementById("add-to-cart-form"),
      addToCartButton = addToCartForm.querySelector(".add-to-cart-button"),
      addToCartDisabled = addToCartButton.querySelector(".disabled-text");

    if (lineItemId === selectedVariantId) {
      console.log("matches");

      console.log("selectedVariantQty = " + selectedVariantQty);
      console.log("lineItemQty = " + lineItemQty);
      console.log("newQty = " + newQty);

      let quantityInput = addToCartForm.querySelector("quantity-input input");

      qtyToUpdate = newQty;
      console.log("qtyToUpdate = " + qtyToUpdate);
      quantityInput.setAttribute("max", newQty);

      if (newQty <= 0) {
        console.log("quantity is now 0, stop cart ajax button");
        addToCartButton.setAttribute("disabled", "");
        addToCartButton.classList.add("disabled--button");
        addToCartButton.classList.add("disabled--item-in-cart");
        console.log("this is in cart");

        addToCartButton.querySelector("span.disabled-text").textContent =
          addToCartButton.dataset.inCart;
      } else {
        addToCartButton.classList.remove("disabled--item-in-cart");
        console.log("quantity is not 0, enable cart ajax button");
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
        addToCartButton.classList.remove("disabled--item-in-cart");
        addToCartButton.querySelector("span.disabled-text").textContent =
          "Sold Out";
      }
    } else {
      console.log("no match");

      if (addToCartButton.classList.contains("disabled--item-in-cart")) {
        addToCartButton.classList.remove("disabled--item-in-cart");
        addToCartButton.querySelector("span.disabled-text").textContent =
          "Sold Out";
      }

      if (addToCartButton.classList.contains("disabled--sold-out")) {
        return;
      } else {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
      }
    }
  }
}

// Dynamic Variant URL
function dynamicVariantURL(form, selectedVariant) {
    console.log("dynamic variant url");
  
    if (!selectedVariant) {
      return;
    }

    let selectedVariantTitle = selectedVariant.title.trim().toLowerCase(),
      configItems = form.querySelectorAll("li.js-config");
  
    console.log(selectedVariantTitle);
  
    configItems.forEach((item) => {
      let url = item.dataset.url,
        itemVariantsDecode = decodeURIComponent(item.dataset.variants),
        itemVariants = JSON.parse(itemVariantsDecode),
        matchedVariant = null;
  
      // console.log(itemVariants);
      // console.log(selectedVariantTitle);
  
      itemVariants.forEach((variant) => {
        // console.log(variant.title);
        if (variant.title.trim().toLowerCase() === selectedVariantTitle) {
          matchedVariant = variant;
          return false;
        }
      });
  
      if (matchedVariant) {
        // console.log("matched variant");
        // console.log(matchedVariant.id);
        // console.log(matchedVariant.title);
  
        let variantURL = url + "?variant=" + matchedVariant.id;
        console.log(variantURL);
        item.querySelector("a").setAttribute("href", variantURL);
      }
    });
  }

function onChangeConfig() {
    console.log("onChangeConfig");
    let configOptions = document.querySelectorAll(".config-row__option");
  
    configOptions.forEach((option) => {
      let optionLink = option.querySelector("a");
  
      optionLink.addEventListener("click", function (event) {
        event.preventDefault();
  
        fetch(optionLink.href)
          .then((response) => response.text())
          .then((data) => {
            let parser = new DOMParser(),
                html = parser.parseFromString(data, "text/html");
  
            console.log(html);
  
            let newProductInfo = html.querySelector(".product-main__info"),
                newProductGallery = html.querySelector(".product-main__gallery"),
                productInfo = document.querySelector(".product-main__info"),
                productGallery = document.querySelector(".product-main__gallery");
  
            var metaOptions = document.querySelectorAll(".meta-option-row__list");
  
            metaOptions.forEach((row) => {
              if (row.querySelector("input:checked")) {
                let rowInput = row.querySelector("input:checked").value,
                    rowId = "#" + row.id,
                    rowInputSelector = rowId + " input[value='" + rowInput + "']",
                    newMetaRow = newProductInfo.querySelector(rowInputSelector);
  
                if (newMetaRow) {
                  newMetaRow.setAttribute("data-ajax", "true");
                  newMetaRow.setAttribute("checked", true);
                  console.log("Row found in new product info:", rowId);
                } else {
                  console.log("Row not found in new product info:", rowId);
                }
              }
            });
  
            productInfo.innerHTML = newProductInfo.innerHTML;
            productGallery.innerHTML = newProductGallery.innerHTML;
  
            let form = document.querySelector(".add-to-cart-form"),
                selectedVariant = productForm.getActiveVariant(form);
  
            let currentCurrency = document.querySelector("html").dataset.currency,
                totalMetaPrice = getPricesFromRows(form, selectedVariant),
                totalVariantPrice = (selectedVariant.price / 100).toFixed(2),
                metaTotalVariantPrice = parseFloat(totalVariantPrice) + parseFloat(totalMetaPrice),
                formattedVariantPrice = currentCurrency + metaTotalVariantPrice.toFixed(2);
  
            document.querySelector(".js-price").textContent = formattedVariantPrice;
            console.log("Updated .js-price with:", formattedVariantPrice);
  
                   // Call onChangeConfig again to reset the event listeners
                   onChangeConfig();
          });
      });
    });
  }

  // Share Cart Functionality
function shareCart() {
  let shareCartButtons = document.querySelectorAll(".share-cart__option")

  if (shareCartButtons.length === 0) {
    console.log("No share cart buttons found");
    return;
  }

  shareCartButtons.forEach((button) => {
    if (button.dataset.listenerAttached === "true") return;
    button.dataset.listenerAttached = "true";
    let type = button.getAttribute("data-type");
    button.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("Share Cart Button Clicked:", type);

     
      if (type === "copy") {
        let clipboardUrl = button.dataset.url,
            clipboardText = button.dataset.dataClipboardText || "Cart URL copied to clipboard";
        navigator.clipboard.writeText(clipboardUrl).then(() => {
          console.log("Cart URL copied to clipboard:", clipboardUrl);
          console.log("Clipboard Text:", clipboardText);
          alert(clipboardText);
        }).catch(err => {
          console.error("Failed to copy text: ", err);
        });
      } else if (type === "email") {
        let cartUrl = button.dataset.url,
            subject = button.dataset.subject,
            body = button.dataset.body;
           
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}%0A${encodeURIComponent(cartUrl)}`;
            
      } else if (type === "sms") {
        let cartUrl = button.dataset.url,
            body = button.dataset.text;

        window.location.href = `sms:?body=${encodeURIComponent(body)}%0A${encodeURIComponent(cartUrl)}`;
      }
    });
});
} 
